var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcons = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "url(#paint0_linear_697_5)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1429 17.0813C14.9832 17.0813 17.2857 14.8245 17.2857 12.0406C17.2857 9.25677 14.9832 7 12.1429 7C9.30253 7 7 9.25677 7 12.0406C7 14.8245 9.30253 17.0813 12.1429 17.0813Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0011 18.7615L16.4297 16.2412",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_697_5",
    x1: 14.7105,
    y1: -5.81579,
    x2: 13,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF03CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B0CB2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcons);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-icons.d57dda162283ae1b598d7b09fa902ad0.svg";